import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mx-auto my-3" }
const _hoisted_2 = { class: "col-sm-12 col-md-6" }
const _hoisted_3 = { class: "col-sm-12 col-md-6" }
const _hoisted_4 = { class: "dashbaord-create-container" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_7 = { class: "row mx-auto my-3" }
const _hoisted_8 = { class: "col-sm-12 col-md-6" }
const _hoisted_9 = { class: "col-sm-12 col-md-6" }
const _hoisted_10 = { class: "dashbaord-create-container" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_13 = { class: "row mx-auto my-3" }
const _hoisted_14 = { class: "col-sm-12 col-md-6" }
const _hoisted_15 = { class: "col-sm-12 col-md-6" }
const _hoisted_16 = { class: "dashbaord-create-container" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_19 = { class: "row mx-auto my-3" }
const _hoisted_20 = { class: "col-sm-12 col-md-6" }
const _hoisted_21 = { class: "col-sm-12 col-md-6" }
const _hoisted_22 = { class: "dashbaord-create-container" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scenario_drafts = _resolveComponent("scenario-drafts")!
  const _component_financial_report = _resolveComponent("financial-report")!
  const _component_tab = _resolveComponent("tab")!
  const _component_scenario_reviews = _resolveComponent("scenario-reviews")!
  const _component_scenario_edits = _resolveComponent("scenario-edits")!
  const _component_scenario_approved = _resolveComponent("scenario-approved")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tabs, {
      options: { useUrlFragment: false },
      "nav-class": "nav nav-pills m-3",
      "nav-item-class": "nav-item col-md-3 col-sm-12 text-center",
      "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
      "nav-item-link-active-class": "active"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-drafting-compass text-primary'></i></h4>",
          name: "Drafts"
        }, {
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_scenario_drafts, {
                  scenario_drafts: _ctx.scenario_drafts,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_drafts", "visit_loading"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                    disabled: _ctx.loading
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                    _createTextVNode(),
                    _createElementVNode("span", { class: "d-none d-md-inline" }, "CREATE NEW SCENARIO", -1)
                  ]), 8, _hoisted_5)
                ]),
                (_ctx.current_partner == 28)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_financial_report, {
                        is_admin: false,
                        is_author: true,
                        onFinancialDates: _ctx.updateFinancialDates,
                        financial_data: _ctx.financial_data
                      }, null, 8, ["onFinancialDates", "financial_data"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-edit text-primary'></i></h4>",
          name: "Reviews"
        }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_scenario_reviews, {
                  scenario_reviews: _ctx.scenario_reviews,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_reviews", "visit_loading"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                    disabled: _ctx.loading
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                    _createTextVNode(),
                    _createElementVNode("span", { class: "d-none d-md-inline" }, "CREATE NEW SCENARIO", -1)
                  ]), 8, _hoisted_11)
                ]),
                (_ctx.current_partner == 28)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_financial_report, {
                        is_admin: false,
                        is_author: true,
                        onFinancialDates: _ctx.updateFinancialDates,
                        financial_data: _ctx.financial_data
                      }, null, 8, ["onFinancialDates", "financial_data"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-i-cursor text-primary'></i></h4>",
          name: "Edits"
        }, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_scenario_edits, {
                  scenario_edits: _ctx.scenario_edits,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_edits", "visit_loading"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                    disabled: _ctx.loading
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                    _createTextVNode(),
                    _createElementVNode("span", { class: "d-none d-md-inline" }, "CREATE NEW SCENARIO", -1)
                  ]), 8, _hoisted_17)
                ]),
                (_ctx.current_partner == 28)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_financial_report, {
                        is_admin: false,
                        is_author: true,
                        onFinancialDates: _ctx.updateFinancialDates,
                        financial_data: _ctx.financial_data
                      }, null, 8, ["onFinancialDates", "financial_data"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-check-circle text-primary'></i></h4>",
          name: "Approved"
        }, {
          default: _withCtx(() => [
            _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_scenario_approved, {
                  scenario_approved: _ctx.scenario_approved,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_approved", "visit_loading"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                    disabled: _ctx.loading
                  }, _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                    _createTextVNode(),
                    _createElementVNode("span", { class: "d-none d-md-inline" }, "CREATE NEW SCENARIO", -1)
                  ]), 8, _hoisted_23)
                ]),
                (_ctx.current_partner == 28)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_financial_report, {
                        is_admin: false,
                        is_author: true,
                        onFinancialDates: _ctx.updateFinancialDates,
                        financial_data: _ctx.financial_data
                      }, null, 8, ["onFinancialDates", "financial_data"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}